import AppContext from "PFApp/app_context";
import { useContext } from "react";

import { getPermittedTypes, loadForSections, PermissionObject } from "./custom_type";

export const useCustomTypes = () => {
  const {
    store: {
      // eslint-disable-next-line camelcase
      currentProfile: { custom_types }
    }
  } = useContext(AppContext);
  return {
    loadForSections: (sections: string | string[]) => loadForSections(sections, custom_types),
    getPermittedTypes: (permitionsObject: PermissionObject) =>
      getPermittedTypes(custom_types, permitionsObject)
  };
};
